import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";

export const fetchVehicleTypes = async ( setVehicleTypes: any, toast: any) => {
  try {
    const response = await axios.get("tl-admin/vehicle-type-list");
    setVehicleTypes(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};
